"use client";

import { FAQSection } from "@/components/sections/faq";
import { faq } from "@/lib/data/services-crisis-management-response";

export function FAQ() {
  return (
    <FAQSection
      eyebrow={faq.eyebrow}
      title={faq.title}
      items={faq.items}
      accent={faq.accent}
    />
  );
}
